import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft, Copy, Check, Info } from 'lucide-react';
const GiftPayment = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    item,
    price,
    type
  } = location.state || {};
  const [copied, setCopied] = useState(false);
  // Convert price string to number (remove ₦ and commas)
  const amountInNaira = price && price !== 'Your Choice' ? parseInt(price.replace(/[₦,]/g, '')) : 0;
  const [customAmount, setCustomAmount] = useState(amountInNaira);
  // Bank Details
  const bankDetails = {
    bankName: 'Access Bank',
    accountName: 'Egbon Ayevbosa Joy',
    accountNumber: '1382036597'
  };
  if (!item) {
    navigate('/');
    return null;
  }
  const copyToClipboard = () => {
    navigator.clipboard.writeText(bankDetails.accountNumber);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };
  return <div className="min-h-screen bg-cream" data-id="element-159">
      <div className="section-container" data-id="element-160">
        <button onClick={() => navigate(-1)} className="flex items-center text-gray-700 hover:text-emerald mb-8 transition-colors" data-id="element-161">
          <ArrowLeft size={20} className="mr-2" data-id="element-162" />
          Back
        </button>

        <div className="max-w-2xl mx-auto" data-id="element-163">
          <h1 className="section-heading" data-id="element-164">Complete Your Gift</h1>

          {/* Selected Gift Summary */}
          <div className="bg-white border border-sage border-opacity-60 p-8 rounded-md shadow-md mb-8" data-id="element-165">
            <h2 className="font-serif text-2xl text-gray-800 mb-2" data-id="element-166">
              Selected Gift
            </h2>
            <p className="text-gray-700 text-lg mb-1" data-id="element-167">{item}</p>
            <p className="text-emerald font-semibold text-2xl mb-4" data-id="element-168">
              {price === 'Your Choice' ? `₦${customAmount.toLocaleString()}` : price}
            </p>
            <p className="text-gray-600 text-sm" data-id="element-169">Category: {type}</p>
          </div>

          {/* Custom Amount Input for "Your Choice" items */}
          {price === 'Your Choice' && <div className="bg-white border border-sage border-opacity-60 p-6 rounded-md shadow-md mb-8" data-id="element-170">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-171">
                Enter Your Gift Amount (₦)
              </label>
              <input type="number" value={customAmount} onChange={e => setCustomAmount(parseInt(e.target.value) || 0)} className="w-full px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-emerald focus:border-emerald outline-none transition-all" placeholder="Enter amount" min="1000" data-id="element-172" />
              <p className="text-xs text-gray-500 mt-1" data-id="element-173">Minimum: ₦1,000</p>
            </div>}

          {/* Bank Transfer Details */}
          <div className="bg-white border border-sage border-opacity-60 p-8 rounded-md shadow-lg" data-id="element-174">
            <div className="text-center mb-8" data-id="element-175">
              <h2 className="font-serif text-2xl text-gray-800 mb-2" data-id="element-176">
                Bank Transfer Details
              </h2>
              <p className="text-gray-600" data-id="element-177">
                Please transfer{' '}
                <span className="font-bold text-emerald" data-id="element-178">
                  ₦{customAmount.toLocaleString()}
                </span>{' '}
                to the account below to complete your gift.
              </p>
            </div>

            <div className="bg-sage bg-opacity-10 p-6 rounded-lg border border-sage border-opacity-30 mb-8" data-id="element-179">
              <div className="space-y-4" data-id="element-180">
                <div className="flex justify-between items-center border-b border-sage border-opacity-20 pb-3" data-id="element-181">
                  <span className="text-gray-600 text-sm uppercase tracking-wide" data-id="element-182">
                    Bank Name
                  </span>
                  <span className="font-serif text-lg text-gray-900 font-medium" data-id="element-183">
                    {bankDetails.bankName}
                  </span>
                </div>

                <div className="flex justify-between items-center border-b border-sage border-opacity-20 pb-3" data-id="element-184">
                  <span className="text-gray-600 text-sm uppercase tracking-wide" data-id="element-185">
                    Account Name
                  </span>
                  <span className="font-serif text-lg text-gray-900 font-medium text-right" data-id="element-186">
                    {bankDetails.accountName}
                  </span>
                </div>

                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center pt-1" data-id="element-187">
                  <span className="text-gray-600 text-sm uppercase tracking-wide mb-2 sm:mb-0" data-id="element-188">
                    Account Number
                  </span>
                  <div className="flex items-center w-full sm:w-auto" data-id="element-189">
                    <span className="font-mono text-xl text-emerald font-bold mr-3 tracking-wider flex-grow sm:flex-grow-0 text-right" data-id="element-190">
                      {bankDetails.accountNumber}
                    </span>
                    <button onClick={copyToClipboard} className="p-2 text-emerald hover:bg-emerald hover:bg-opacity-10 rounded-full transition-colors relative group" title="Copy Account Number" data-id="element-191">
                      {copied ? <Check size={20} data-id="element-192" /> : <Copy size={20} data-id="element-193" />}
                      {copied && <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-gray-800 text-white text-xs py-1 px-2 rounded opacity-100 transition-opacity whitespace-nowrap" data-id="element-194">
                          Copied!
                        </span>}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex items-start bg-blue-50 p-4 rounded-md mb-8" data-id="element-195">
              <Info size={20} className="text-blue-600 mt-1 mr-3 flex-shrink-0" data-id="element-196" />
              <p className="text-sm text-blue-800" data-id="element-197">
                <span className="font-bold" data-id="element-198">Important:</span> After making the
                transfer, please send your proof of payment to us via WhatsApp
                or Email so we can acknowledge your generous gift.
              </p>
            </div>

            <button onClick={() => navigate('/')} className="w-full px-8 py-4 bg-emerald text-white font-sans text-sm uppercase tracking-wider hover:bg-emerald-dark transition-all duration-300 shadow-md rounded-md" data-id="element-199">
              Done
            </button>
          </div>

          <div className="mt-8 text-center" data-id="element-200">
            <p className="text-gray-600 italic font-script text-xl mb-4" data-id="element-201">
              Thank you for your generous gift!
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default GiftPayment;